export default "__VITE_ASSET__edea2c6e__"